import React, { useState } from 'react';
import { IListItem, IListOption, Item, Items } from 'design-v2/common/RadioList/types';
import style from './style.module.css';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import classNames from 'classnames';
export const ListItem = (props: IListItem) => {
  return (
    <div
      className={classNames({
        [style.iconHorizon]: true,
        [style.boldTailTitle]: props.boldTitle,

      })}
      onClick={props.handleClick}
    >
      <div>{props.icon}</div>
      <div className={classNames({
        [style.title]: true,
        [style.titleItem]: props.isTitleItem,
        [style.clickableItem]: !!props.handleClick
      })}>
        <span style={props?.style}>{props.title}</span>
      </div>
    </div>
  );
};
export const ListOption = (props: IListOption) => {
  const { hiddenRadio = false } = props
  return (
    <div
      className={classNames({
        [style.listHorizon]: true,
        [style.hiddenBorder]: props.hiddenBorder,
        [style.listHorizonSelected]: props.checked,
      })}
      style={props?.style}
      onChange={props.onChange}
      onClick={props.onClick}
      data-testid={props.dataTestId}
    >
      <ListItem
        boldTitle={props.boldTitle}
        title={props.title}
        icon={props.icon}
        style={props?.contentStyle}
      />
      <div className={style.title}>
        <span
          className={classNames({
            [style.tailTitle]: !props.disabled,
            [style.tailTitleDisabled]: props.disabled,
          })}
        >
          {props.tailTitle}
        </span>
        {!hiddenRadio ? <Radio
          disabled={props.disabled}
          checked={props.checked}
          value={props.index}
          name="radio-buttons"
        /> : null}
      </div>
    </div>
  );
};
export default function RadioList(props: Items) {
  const [selected, setSelected] = useState<number>(-1);
  const handleItemClick = (index: number) => {
    setSelected(index);
    props.handleClick(index);
  };

  return (
    <div
      className={classNames({
        [style.root]: true,
      })}
    >
      {props.items.map((item, i) => {
        return (
          <ListOption
            key={i}
            title={item.title}
            icon={item.children}
            index={i}
            onClick={() => handleItemClick(i)}
            checked={selected === i}
          />
        );
      })}
    </div>
  );
}
